import {Md5} from "ts-md5/dist/md5";

const _sha512 = require('js-sha512');

export class HashUtils {

    static sha512(input: string): string {
        return _sha512(input);
    }

    static md5(input:string):any{
        return Md5.hashStr(input);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/hash.utils.ts